import { type IssueTypeStatus } from "@overmap-ai/common"
import { selectIssueTypeStatusById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { issueStatusTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuIconWithWrapper, type LuIconWithWrapperProps } from "./LuIconWithWrapper"
import type { IconsProps } from "./typings"

interface IssueTypeStatusIconProps extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	issueTypeStatusId: IssueTypeStatus["uuid"]
}

export const IssueTypeStatusIcon = memo<IssueTypeStatusIconProps>((props) => {
	const { ref, issueTypeStatusId, ...rest } = props

	const issueTypeStatus = useAppSelector(selectIssueTypeStatusById(issueTypeStatusId))!

	const { icon } = issueStatusTypeData[issueTypeStatus.type]

	return <LuIconWithWrapper ref={ref} color={issueTypeStatus.color} icon={icon} {...rest} />
})
IssueTypeStatusIcon.displayName = "IssueTypeStatusIcon"

interface IssueTypeStatusIconsProps extends IconsProps {
	issueTypeStatusIds: IssueTypeStatus["uuid"][]
}

export const IssueTypeStatusIcons = memo<IssueTypeStatusIconsProps>((props) => {
	const { ref, className, issueTypeStatusIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{issueTypeStatusIds.slice(0, max ?? issueTypeStatusIds.length).map((status, index) => (
				<IssueTypeStatusIcon issueTypeStatusId={status} key={`${status}-${index}`} background />
			))}
		</span>
	)
})
IssueTypeStatusIcons.displayName = "IssueTypeStatusIcons"
